import React from "react";
import { Typography, Form, Input, Button, Upload, Select, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";

const { Title } = Typography;
const { Option } = Select;

function CreateTask() {

  const { projectId } = useParams();
  const navigate = useNavigate();

  const saveTask = async (values) => {

    try {

      const newTask = {
        projectId,
        summary: values.summary,
        description: values.description,
        reporter: values.reporter,
        assignee: values.assignee,
        sprint: values.sprint,
        priority: values.priority,
        date: new Date().toISOString().split("T")[0],
      };

      const token = localStorage.getItem("access-token");

      const response = await fetch("https://rhrmapi.up2dateinc.com/api/tasks", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(newTask)
      });

      const data = await response.json();

      if (response.ok) {

        message.success("Task Created Successfully");

        navigate(`/admin/backlogs/${projectId}`);

      } else {

        message.error(data.message || "Failed to create task");

      }

    } catch (error) {

      message.error("Server Error");

    }

  };

  return (
    <div>

      <Title level={3}>Create Task</Title>

      <Form layout="vertical" onFinish={saveTask} style={{ maxWidth: 800 }}>

        <Form.Item label="Project ID">
          <Input value={projectId} disabled />
        </Form.Item>

        <Form.Item name="summary" label="Summary" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="description" label="Description" rules={[{ required: true }]}>
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item label="Attachment">
          <Upload>
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
          <p>N.B: Only pdf | docx | jpg | png allowed</p>
        </Form.Item>

        <Form.Item name="reporter" label="Reporter">
          <Input />
        </Form.Item>

        <Form.Item name="assignee" label="Assignee" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="sprint" label="Sprint">
          <Input />
        </Form.Item>

        <Form.Item name="priority" label="Priority" rules={[{ required: true }]}>
          <Select>
            <Option value="High">High</Option>
            <Option value="Medium">Medium</Option>
            <Option value="Low">Low</Option>
          </Select>
        </Form.Item>

        <Button type="primary" htmlType="submit">
          Create Task
        </Button>

      </Form>

    </div>
  );
}

export default CreateTask;